import { defineStore } from "pinia";
import axios from "axios";

export const useTimeStore = defineStore("time", {
  state: () => ({
    serverTimestamp: null,
    timezone: "America/Mexico_City",
    lastSync: null,
  }),

  getters: {
    serverDate(state) {
      return state.serverTimestamp
        ? new Date(state.serverTimestamp)
        : null;
    },

    // 🗓️ Día actual (MARTES)
    serverDay(state) {
      if (!state.serverTimestamp) return null;
      return new Date(state.serverTimestamp)
        .toLocaleDateString("es-MX", {
          weekday: "long",
          timeZone: state.timezone,
        })
        .toUpperCase();
    },

    // ⏰ Hora legible
    serverTimeFormatted(state) {
      if (!state.serverTimestamp) return null;
      return new Date(state.serverTimestamp)
        .toLocaleString("es-MX", {
          timeZone: state.timezone,
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        });
    },
  },

  actions: {
    async syncServerTime() {
      try {
        const { data } = await axios.get(
          "https://mvexpress.mx/api/timezone/server-time"
        );

        this.serverTimestamp = data.timestamp;
        this.timezone = data.timezone;
        this.lastSync = Date.now();

        console.log("🕒 Hora servidor sincronizada:", data.locale);
      } catch (err) {
        console.error("❌ Error sincronizando hora del servidor", err);
      }
    },

    // ⏳ Simular reloj avanzando (sin pedir API cada segundo)
    tick() {
      if (this.serverTimestamp) {
        this.serverTimestamp += 1000;
      }
    },
  },
});
